export default {
  primary: {
    fontWeight: 600,
    fontSize: '1.4rem'
  }
};
